import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthTokens, MeResponse } from '@ah/contracts';

/**
 * Real auth store for the admin dashboard (replaces the temporary `?token=`
 * bridge — see shared/stores/session.store.ts, now deleted). Same shape as
 * apps/therapist-portal/src/features/auth/auth.store.ts / mobile's.
 */
export interface AuthState {
  tokens: AuthTokens | null;
  user: MeResponse | null;
  setSession: (payload: { tokens: AuthTokens; user: MeResponse }) => void;
  signOut: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      tokens: null,
      user: null,
      setSession: ({ tokens, user }) => set({ tokens, user }),
      signOut: () => set({ tokens: null, user: null }),
    }),
    {
      name: 'ah.admin.auth',
      partialize: (state) => ({ tokens: state.tokens }),
    },
  ),
);
